<template>
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <h4 class="p-b-20">{{ $t("prof") }}</h4>
    <div class="">
      <div class="col-lg-5 pl-0">
        <div
          v-if="mssg"
          align="center"
          class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ mssg }}
          </p>
        </div>
        <div
          v-else-if="Errormssg"
          align="center"
          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ Errormssg }}
          </p>
        </div>
        <form @submit.prevent="updateprofile">
          <div class="">
            <div class="form-group">
              <label>{{ $t("full_name") }}</label>
              <input
                type="text"
                name="name"
                v-model="fullname"
                class="form-control"
                required
                @keypress="isLetter($event)"
              />
              <div
                v-show="selectNotification !== ''"
                class="alert-danger alert-dismissible fade show"
              >
                <p>{{ selectNotification }}</p>
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t("email") }}</label>
              <input
                type="email"
                name="email"
                v-model="email"
                class="form-control"
                readonly
              />
            </div>
            <div class="form-group">
              <label>{{ $t("address") }}</label>
              <textarea
                rows="4"
                style="resize:none"
                class="form-control"
                name="company_address"
                v-model="address"
                required
              ></textarea>
            </div>

            <div class="form-group">
              <label for="InputNumber">{{ $t("phone_num") }}</label>
              <div class="form-group">
                <input class="form-control" type="tel" id="phone_number" />
              </div>
              <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                {{ ErrorPhone }}
              </p>
            </div>

            <div class="row m-t-20">
              <div class="form-group col-md-4">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="selectNotification !== ''"
                >
                  {{ $t("save") }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "EditProfile",
  data() {
    return {
      fullname: "",
      email: "",
      address: "",
      user_rights: "Staff",
      isLoading: true,
      fullPage: true,
      ErrorPhone: "",
      mssg: "",
      Errormssg: "",
      countrycodes: [],
      iti: "",
      selectNotification: "",
    };
  },
  mounted() {
    var input = document.querySelector("#phone_number");
    this.iti = intlTelInput(input, {
      separateDialCode: true,
      formatOnDisplay: false,
      utilsScript: utils,
    });
    this.fetchProfile().then(() => {
      this.fullname = this.profile.fullname;
      this.email = this.profile.email;
      // this.number = this.profile.phone;
      this.address = this.profile.address;
      var number = "+" + this.profile.phone.toString();
      // console.log((number))
      this.iti.setNumber(number);
      // console.log(this.iti.isValidNumber(), "number validation");
      // console.log(this.iti, "checking iti presence");
      if (!this.iti.isValidNumber()) {
        number =
          "+" +
          this.profile.countryCode.toString() +
          this.profile.phone.toString();
        // console.log((number))
        this.iti.setNumber(number);
      }
      // this.countrycode = code;
      this.isLoading = false;
    });
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    ...mapActions(["updateProfile", "fetchProfile"]),
    updateprofile() {
      let number = this.iti.getNumber().slice(1);
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = "This phone number is not valid";
      } else {
        this.isLoading = true;
        const updatedprofile = {
          fullname: this.fullname,
          address: this.address,
          phone: `${parseInt(number)}`,
        };
        this.updateProfile(updatedprofile)
          .then((res) => {
            this.isLoading = false;
            this.mssg = res.data.payload.message;
            setTimeout(() => {
              this.mssg = "";
            }, 4000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },
  watch: {
    fullname: {
      handler() {
        if (/^[a-zA-Z\s]*$/.test(this.fullname))
          return (this.selectNotification = "");
        else this.selectNotification = "Must conain only Letters";
      },
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
<i18n>
{
	"en": {
		"address": "Address",
		"email": "Email",
		"full_name": "Full Name",
		"phone_num": "Phone Number",
		"prof": "My Profile",
		"save": "Save"
	},
	"es": {
		"address": "Dirección",
		"email": "Email",
		"full_name": "Nombre completo",
		"phone_num": "Número de teléfono",
		"prof": "Mi perfil",
		"save": "Salvar"
	},
	"fr": {
		"address": "Adresse",
		"email": "E-mail",
		"full_name": "Nom et prénom",
		"phone_num": "Numéro de téléphone",
		"prof": "Mon profil",
		"save": "enregistrer"
	},
	"sw": {
		"address": "Anwani",
		"email": "Barua pepe",
		"full_name": "Jina kamili",
		"phone_num": "Nambari ya simu",
		"prof": "Profaili yangu",
		"save": "Okoa"
	}
}
</i18n>
